import * as React from 'react';
import { SvgComponentProps, Svg } from './svg-component';

export const LockCircleIcon = ({ size, ...rest }: SvgComponentProps) => (
    <Svg width={size || 64} height={size || 64} viewBox="0 0 64 64" fill="none" {...rest}>
        <path
            d="M50.285 25.143H13.714a4.57 4.57 0 0 0-4.571 4.571v27.429a4.57 4.57 0 0 0 4.571 4.571h36.571a4.57 4.57 0 0 0 4.572-4.571V29.714a4.57 4.57 0 0 0-4.572-4.571Z"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M48 25.143v-6.857a16 16 0 0 0-32 0v6.857"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M32 45.714a2.286 2.286 0 1 0 0-4.571 2.286 2.286 0 0 0 0 4.571Z"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Svg>
);
